import OnboardingBillingContainer from './containers/OnboardingBillingContainer';

export default OnboardingBillingContainer;
